import { h } from "preact";
import { CloseCircle } from "../../helpers/icons";

/** One basketed swatch. The whole chip removes it — not a decrement. */
export default function SwatchBasketChip({ entry, quantity, onRemove }) {
  const strings = window.localeStrings.swatch_details;

  return (
    <button
      type="button"
      className="swatch-details-drawer__basket-chip"
      aria-label={strings.remove_swatch.replace(
        "[name]",
        entry.optionValueName,
      )}
      onClick={onRemove}
    >
      <span className="swatch-details-drawer__basket-chip-media">
        {entry.image && (
          <img
            className="swatch-details-drawer__basket-chip-image"
            src={window.getSizedImageUrl(entry.image.url, "100x")}
            alt=""
            loading="lazy"
          />
        )}
      </span>
      <span className="swatch-details-drawer__basket-chip-remove">
        <CloseCircle />
      </span>
      {quantity > 1 && (
        <span className="swatch-details-drawer__basket-chip-quantity">
          {quantity}
        </span>
      )}
    </button>
  );
}
